import { render } from "./ProgressPage.vue?vue&type=template&id=390583aa&ts=true"
import script from "./ProgressPage.vue?vue&type=script&lang=ts"
export * from "./ProgressPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__